<template>
  <div class="infobar">
    <div class="row no-gutters">
      <div class="col-2 infobar-name">X:</div>
      <div class="col-10 infobar-value">{{formatDecimal(mousePositionX, 0)}}mm</div>
    </div>
    <div class="row no-gutters">
      <div class="col-2 infobar-name">Y:</div>
      <div class="col-10 infobar-value">{{formatDecimal(mousePositionY, 0)}}mm</div>
    </div>
  </div>
</template>

<style scoped>
.infobar {
  font-size: 11px;
  color: #c7c7c7;
}
.infobar .row {
  line-height: 20px;
  vertical-align: middle;
  margin-top: 2px;
}
.infobar-name {
  line-height: 20px;
  vertical-align: middle;  
  padding-top: 1px;
}
.infobar-value {
  width: 100%;
  border: 1px solid #404040;
  border-radius: 4px;
  background-color: #202020;
  padding: 1px 2px 1px 4px;
  color: #d7d7d7;
}
</style>

<script>
export default {
  name: 'EditorInfoBar',
  props: {
    mousePositionX: Number,
    mousePositionY: Number,
  }
}
</script>